import React from "react";
// Components
import Table from "./../../../../components/Table/Table";
import { MacEsScenarioData } from "../Result/MacEs";

// Helpers
import { utils } from "./../../../../helpers";

// i18n
import { __ } from "@wordpress/i18n";

/** Constants for reusable values */
const CLASSES = {
    TEXT_LEFT: "text-left",
};

/** Strings with i18n */
const LABELS = {
    loanAmount: __("Empréstimo", "df-simulators"),
    paymentValue: __("Prestação mensal", "df-simulators"),
    effortRate: __("Taxa de esforço", "df-simulators"),
    canPayInstallment: __("Pode pagar a prestação?", "df-simulators"),
    operatingCosts: __("Despesas e impostos", "df-simulators"),
    savingsNeeded: __("Poupança necessária", "df-simulators"),
    hasEnoughSavings: __("Tem poupança suficiente?", "df-simulators"),
    ltv: __("LTV", "df-simulators"),
    yes: __("Sim", "df-simulators"),
    no: __("Não", "df-simulators"),
};

interface TabCompositionProps {
    scenarioData: MacEsScenarioData;
}

/** Renders a yes/no value with the same green/red convention used across the block */
const renderBoolean = (value: boolean): string =>
    `<span class="text-${value ? "green-100" : "red-100"} font-bold">${value ? LABELS.yes : LABELS.no}</span>`;

/** Component */
const TabComposition: React.FC<TabCompositionProps> = ({ scenarioData }) => {
    const { results } = scenarioData;
    const { dstiRatio } = results.paymentValue;

    const effortRate = dstiRatio.achieved * 100;
    const canPayInstallment = dstiRatio.achieved <= dstiRatio.expected;

    const savingsNeeded = results.propertyValue - results.loanAmount + results.operatingCosts.total;
    const hasEnoughSavings = savingsNeeded >= 0;

    return (
        <Table
            data={[
                [
                    { value: LABELS.loanAmount, className: CLASSES.TEXT_LEFT },
                    {
                        value: utils.toEuro(results.loanAmount || 0),
                        className: CLASSES.TEXT_LEFT,
                    },
                ],
                [
                    { value: LABELS.paymentValue, className: CLASSES.TEXT_LEFT },
                    {
                        value: utils.toEuro(results.paymentValue.paymentValue || 0),
                        className: CLASSES.TEXT_LEFT,
                    },
                ],
                [
                    { value: LABELS.effortRate, className: CLASSES.TEXT_LEFT },
                    {
                        value: utils.toRound(effortRate) + "%",
                        className: CLASSES.TEXT_LEFT,
                    },
                ],
                [
                    { value: LABELS.canPayInstallment, className: CLASSES.TEXT_LEFT },
                    {
                        value: renderBoolean(canPayInstallment),
                        className: CLASSES.TEXT_LEFT,
                    },
                ],
                [
                    { value: LABELS.operatingCosts, className: CLASSES.TEXT_LEFT },
                    {
                        value: utils.toEuro(results.operatingCosts.total || 0),
                        className: CLASSES.TEXT_LEFT,
                    },
                ],
                [
                    { value: LABELS.savingsNeeded, className: CLASSES.TEXT_LEFT },
                    {
                        value: utils.toEuro(savingsNeeded),
                        className: CLASSES.TEXT_LEFT,
                    },
                ],
                [
                    { value: LABELS.hasEnoughSavings, className: CLASSES.TEXT_LEFT },
                    {
                        value: renderBoolean(hasEnoughSavings),
                        className: CLASSES.TEXT_LEFT,
                    },
                ],
                [
                    { value: LABELS.ltv, className: CLASSES.TEXT_LEFT },
                    {
                        value: utils.toRound(results.ltv.achieved * 100) + "%",
                        className: CLASSES.TEXT_LEFT,
                    },
                ],
            ]}
        />
    );
};

export default TabComposition;
